import React, { useEffect, useState } from "react";
import { getWithExpiry, setWithExpiry } from '../../common';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const IntroCourse = (props) => {

    const [courseTitle, setCourseTitle] = useState('');
    const [courseContent, setCourseContent] = useState('');
    const [translation] = useTranslation("translations");

    useEffect(() => {

        const savedCourse = getWithExpiry( 'sy_intro_course_data' );

        if ( savedCourse ) {
            setCourseTitle( savedCourse.course_title);
            setCourseContent( savedCourse.course_content );
        } else {

            (async () => {

                const response = await fetch(`https://learn.sustainchange.se/wp-json/sustainchangelms/v1/getcoursenav/?courseid=27182`);
                const courseResponse = await response.json();
    
                if ( courseResponse ) {

                    //console.log( courseResponse );
    
                    if ( courseResponse.success === true ) {

                        setWithExpiry( 'sy_intro_course_data', courseResponse.data );

                        setCourseTitle( courseResponse.data.course_title);
                        setCourseContent( courseResponse.data.course_content );
    
                    }
                }
    
            })()

        }

    }, [props.userOnboarded, props.loading]);

    return (
      <div className="intro-course-wrap bg-white px-3 py-3 mb-3 rounded-3 d-inline-block w-100">
        <div className="d-flex align-items-start flex-column">
          <div>
            <h5>{courseTitle}</h5>
            <div
              className="opacity-half font-size-medium intro-course-content mt-3"
              dangerouslySetInnerHTML={{ __html: courseContent }}
            ></div>
          </div>
          <div className="mt-3 mt-lg-0">
            <Link className="btn btn-secondary rounded-pill mt-3 font-size-medium" to="/anvandarguide">
              <span className="pe-2">{translation("get_started")}</span>
              <i className="fa fa-angle-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

      </div>
    );

};

export default IntroCourse;